export class SpouseInformation{
  maritalStatus:string = '';
  firstName:string ='';
  middleName:string = '';
  lastName:string = '';
}
